import api from "./api.service";
import { adminTokenService } from "./admin.token.service";

export interface DashboardData {
    userCount: number;
    carrierServiceCount: number;
    carrierCount: number;
    roleCount: number;
    moduleCount: number;
    customerCount: number;
    orderCount?: number;
    ordersByDate?: Array<{ date: string; count: number }>;
}

export interface GetDashboardResponse {
    statusCode: number;
    message: string;
    data: DashboardData;
}

class AdminDashboardService {
    /**
     * Fetches statistics for the admin dashboard.
     * @param startDate Optional start date filter (YYYY-MM-DD).
     * @param endDate Optional end date filter (YYYY-MM-DD).
     * @returns A promise with the dashboard statistics.
     */
    async getDashboardData(startDate?: string, endDate?: string): Promise<GetDashboardResponse> {
        const token = adminTokenService.getAdminToken();
        try {
            const params: Record<string, string> = {};
            if (startDate) params.startDate = startDate;
            if (endDate) params.endDate = endDate;

            const response = await api.get<GetDashboardResponse>(
                "/admin/get-dashboard",
                {
                    headers: {
                        Authorization: `${token}`,
                    },
                    params
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error fetching dashboard data:", error);
            throw error;
        }
    }
}

export const adminDashboardService = new AdminDashboardService();
